export default {
	recommendedLength: 15,
};
